import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import Vuelidate from 'vuelidate';
import VueSweetalert2 from 'vue-sweetalert2';
import VueSession from 'vue-session';

import App from './App.vue';
import router from './router';
import store from './store';
import RevampAPI from './services/revampAPI';

// Bootstrap
Vue.use(BootstrapVue);

// Vuelidate for validate form
Vue.use(Vuelidate);

// SweetAlert
const options = {
  confirmButtonColor: '#5e51a1',
};
Vue.use(VueSweetalert2, options);

// Vue Session
const optionSession = {
  persist: true,
};
Vue.use(VueSession, optionSession);

// Init Revamp API Service
RevampAPI.init(process.env.VUE_APP_CMS_REVAMP_API, router, store);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    scrollToAnchor(hash) {
      setTimeout(() => {
        const element = document.getElementById(hash.replace(/#/, ''));
        if (element && element.scrollIntoView) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        }
      }, 100);
    },
  },
  render: (h) => h(App),
}).$mount('#app');
